import { useEffect } from 'react'
import './Toast.css'

const ICONS = {
  success: '\u2713',
  error: '\u2715',
  warning: '\u26A0',
  info: '\u2139',
}

export default function Toast({ message, type = 'info', duration = 4000, onClose }) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(onClose, duration)
      return () => clearTimeout(timer)
    }
  }, [duration, onClose])

  return (
    <div className={`notification-toast notification-${type}`} role="status" aria-live="polite">
      <div className="notification-icon">{ICONS[type] || ICONS.info}</div>
      <div className="notification-message">{message}</div>
      <button className="notification-close" onClick={onClose} aria-label="Dismiss">&times;</button>
    </div>
  )
}
